import { Injectable } from '@angular/core';
import { QueryBus, Wrapper } from '@skylab-angular-shared/core';

import { ReportExporterServiceBase } from '@skylab-shared/business';
export { ReportExporterServiceBase };

@Injectable({ providedIn: 'root'})
@Wrapper(ReportExporterServiceBase)
export class ReportExporterService {
    public constructor(
        queryBus: QueryBus
    ) { }
}
